import { apiHelpers } from './api';
import { ProbationInstructionItem, ApiResponse, ProbationInstructionItemFormData, ProbationInstructionItemList } from '../types/models';
import { convertToUtcDate } from '../utils/dateUtils';

export class ProbationInstructionItemService {
  // Получить все стажировки (упрощенная версия для списка)
  static async getAll(): Promise<ApiResponse<ProbationInstructionItemList[]>> {
    return apiHelpers.get<ProbationInstructionItemList[]>(`/ProbationInstructionItem/GetAll`);
  }

  // Получить стажировку по ID
  static async getById(id: number): Promise<ApiResponse<ProbationInstructionItem>> {
    return apiHelpers.get<ProbationInstructionItem>(`/ProbationInstructionItem/Get?id=${id}`);
  }

  // Получить стажировки по сотруднику (упрощенная версия для списка)
  static async getByEmployee(employeeId: number): Promise<ApiResponse<ProbationInstructionItemList[]>> {
    return apiHelpers.get<ProbationInstructionItemList[]>(`/ProbationInstructionItem/GetByEmployee?employeeId=${employeeId}`);
  }

  // Создать новую стажировку
  static async create(data: ProbationInstructionItemFormData): Promise<ApiResponse<ProbationInstructionItem>> {
    const utcData = {
      ...data,
      startDate: convertToUtcDate(data.startDate),
      finishDate: convertToUtcDate(data.finishDate),
      docDate: convertToUtcDate(data.docDate),
    };
    return apiHelpers.post<ProbationInstructionItem>('/ProbationInstructionItem/Create', utcData);
  }

  // Обновить стажировку
  static async update(id: number, data: ProbationInstructionItemFormData & { id: number }): Promise<ApiResponse<void>> {
    const utcData = {
      ...data,
      startDate: convertToUtcDate(data.startDate),
      finishDate: convertToUtcDate(data.finishDate),
      docDate: convertToUtcDate(data.docDate),
    };
    return apiHelpers.put<void>(`/ProbationInstructionItem/Update/${id}`, utcData);
  }

  // Удалить стажировку
  static async delete(id: number): Promise<ApiResponse<void>> {
    return apiHelpers.delete<void>(`/ProbationInstructionItem/Delete/${id}`);
  }
}